export default function ({ route, redirect, $config, i18n }) {
	if (route.path === '/admin') {
		return redirect($config.apiBaseUrl[i18n.locale] + '/admin');
	}
}
